import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
var CatTab = function CatTab(props) {
  var navigate = useNavigate();
  var params = useParams();
  var cat = props.cat,
    option = props.option;
  if (!option) {
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return navigate({
          pathname: "/".concat(params.type, "/").concat(cat.slug)
        });
      },
      className: "header-tab ".concat(params.cat === cat.slug ? ' active' : '')
    }, /*#__PURE__*/React.createElement("h3", null, cat.plural ? cat.plural : cat.name));
  } else {
    return /*#__PURE__*/React.createElement("option", {
      value: cat.slug,
      key: "cat-".concat(cat)
    }, cat.name);
  }
};
export default CatTab;